export default __webpack_public_path__ + "static/media/checklist.2f590eb4.svg";